import DashboardItem, { proseClasses } from './dashboard-item';
import Heading from 'tio-ui/components/heading';
import { LinkTo } from '@ember/routing';
import { PhLink, PhLinkBreak } from 'ember-phosphor-icons';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { htmlSafe } from '@ember/template';
import { dashboardIconSizes } from 'tio-employee/utils/wellness-insights';

const documentUploadLinkQuery = {
  providers: 'nslds,statement',
};

const feedbackQuery = {
  decline_account: true,
};

export default class WellnessInsightsDashAccountCreationPrompt extends DashboardItem {
  @service declare router: RouterService;

  get currentRoute(): string {
    return this.router.currentRouteName!;
  }

  get iconClass() {
    const definition = this.args.componentDefinition;
    switch (definition.type) {
      case 'add_account':
        return PhLink;
      case 'doesnt_have_loans':
      case 'not_adding_loans':
        return PhLinkBreak;
      default:
        throw new Error(
          `WellnessInsightsComponentDefinition id ${definition.id} type invalid for WellnessInsightsDashAccountCreationPrompt component`
        );
    }
  }

  <template>
    <div class="tio-col-extra-loose items-center text-center">
      <div class="tio-col-tight items-center">
        {{#let this.iconClass as |IconComponent|}}
          <IconComponent @size={{dashboardIconSizes.md}} class="tio-fg-brand" />
        {{/let}}
        <Heading @level={{2}}>{{this.translate "account_creation_prompt.title"}}</Heading>
      </div>
      <div class="max-w-2xl {{proseClasses}}">
        {{this.translate "account_creation_prompt.body"}}
      </div>
      <div class="max-w-2xl {{proseClasses}}">
        {{htmlSafe @componentDefinition.text}}
      </div>
      <div class="tio-col-tight items-center">
        <LinkTo
          @route="authenticated.observability.upload"
          @query={{documentUploadLinkQuery}}
          class="tio-btn tio-btn--primary tio-btn--md text-center"
          data-test-hook="wellness-account-prompt__add-account"
        >
          {{this.translate "account_creation_prompt.cta_text"}}
        </LinkTo>
        <LinkTo
          @route={{this.currentRoute}}
          @query={{feedbackQuery}}
          class="app-text-link app-text-link--inline"
        >
          {{this.translate "account_creation_prompt.cta_alt"}}
        </LinkTo>
      </div>
    </div>
  </template>
}
